var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"d-flex align-center"},[_c('v-spacer'),_c('v-col',{staticClass:"col-6 d-flex justify-center"},[_c('v-img',{attrs:{"src":require("@/assets/Warberg_IC_logo.png"),"max-height":"200","max-width":"200","contain":""}})],1),_c('v-spacer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }